module.exports = __webpack_public_path__ + "static/eco_01-ba2862894d7a514469888435f0043600.jpg";